import React from 'react'

const badgeStyles = {
  primary: {
    backgroundColor: '#e3f2fd',
    color: '#1976d2',
    borderColor: '#bbdefb'
  },
  secondary: {
    backgroundColor: '#f3e5f5',
    color: '#7b1fa2',
    borderColor: '#ce93d8'
  },
  success: {
    backgroundColor: '#e8f5e8',
    color: '#2e7d32',
    borderColor: '#a5d6a7'
  },
  info: {
    backgroundColor: '#e0f2f1',
    color: '#00695c',
    borderColor: '#80cbc4'
  },
  warning: {
    backgroundColor: '#fff8e1',
    color: '#f57c00',
    borderColor: '#ffcc02'
  },
  danger: {
    backgroundColor: '#ffebee',
    color: '#d32f2f',
    borderColor: '#ef9a9a'
  },
  grey: {
    backgroundColor: '#f5f5f5',
    color: '#616161',
    borderColor: '#e0e0e0'
  },
  equipment: {
    backgroundColor: '#e8eaf6',
    color: '#3949ab',
    borderColor: '#9fa8da'
  }
}

export default function ModernBadge({
  variant = 'primary',
  children,
  icon,
  iconPosition = 'left',
  size = 'medium',
  style = {},
  className = '',
  ...props
}) {
  const baseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: size === 'small' ? '4px 8px' : size === 'large' ? '8px 16px' : '6px 12px',
    borderRadius: '20px',
    fontSize: size === 'small' ? '12px' : size === 'large' ? '14px' : '13px',
    fontWeight: '500',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    border: '1px solid',
    whiteSpace: 'nowrap',
    transition: 'all 0.2s ease',
    cursor: 'default',
    ...badgeStyles[variant],
    ...style
  }

  const iconStyle = {
    fontSize: size === 'small' ? '12px' : size === 'large' ? '14px' : '13px',
    opacity: 0.8
  }

  const renderContent = () => {
    if (!icon) return children

    // Mapeo de iconos de Semantic UI a FontAwesome
    const iconMap = {
      'clock': 'fas fa-clock',
      'check circle': 'fas fa-check-circle',
      'times circle': 'fas fa-times-circle',
      'check': 'fas fa-check',
      'ban': 'fas fa-ban',
      'paper plane': 'fas fa-paper-plane',
      'edit': 'fas fa-edit',
      'money bill alternate': 'fas fa-university',
      'exchange': 'fas fa-exchange-alt',
      'question': 'fas fa-question-circle',
      'market': 'fas fa-shopping-cart',
      'close': 'fas fa-times',
      'shopping cart': 'fas fa-shopping-cart',
      'truck': 'fas fa-truck',
      'pause': 'fa-solid fa-pause',
      'dollar-sign': 'fas fa-dollar-sign',
      'coins': 'fas fa-coins',
      'user': 'fas fa-user',
      'wrench': 'fas fa-wrench',
      'archive': 'fas fa-archive',
      'car': 'fas fa-car',
      'bus': 'fas fa-bus',
      'motorcycle': 'fas fa-motorcycle',
      'bolt': 'fas fa-bolt',
      'arrow-down': 'fas fa-arrow-down',
      'arrow-up': 'fas fa-arrow-up',
      'network wired': 'fas fa-network-wired',
      'router': 'fa-solid fa-router',
      'ethernet': 'fa-solid fa-ethernet'
    }

    const fontAwesomeClass = iconMap[icon] || `fas fa-${icon}`

    if (iconPosition === 'left') {
      return (
        <>
          <i className={fontAwesomeClass} style={iconStyle} />
          {children}
        </>
      )
    } else {
      return (
        <>
          {children}
          <i className={fontAwesomeClass} style={iconStyle} />
        </>
      )
    }
  }

  return (
    <span
      className={`modern-badge modern-badge--${variant} ${className}`}
      style={baseStyle}
      {...props}
    >
      {renderContent()}
    </span>
  )
}

